import { useCallback } from "react";

import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuReloadPageItem(props) {
  const handleClick = useCallback((_event) => {
    location.reload();
  }, []);

  /**************************************************************************************************/

  return (
    <ActionMenuBaseItem
      onClick={handleClick}
      label={{
        text: "Reload Page",
        icon: "rotate",
      }}
      {...props}
    />
  );
};
